import { VxSwalError } from '@voxie/frontend-components';
import { HTTP_INTERNAL_SERVER_ERROR } from '~/support/HttpStatuses';

export function catchRequestError(error, log = true) {
    if (log) {
        console.error(error);
    }

    if (!error?.response?.status || error?.response?.status >= HTTP_INTERNAL_SERVER_ERROR) {
        return 'Something went wrong.';
    } else {
        const data = error.response?.data;
        return data?.message || data?.errors?.[0]?.detail || 'Something went wrong.';
    }
}

export function throwSwalRequestError(error) {
    throw new VxSwalError(catchRequestError(error));
}

export function sendFormRequest(url, data, method = 'post') {
    const form = document.createElement('form');
    form.method = method;
    form.action = url;

    for (const key in data) {
        if (Array.isArray(data[key])) {
            data[key].forEach((value) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = `${key}[]`;
                input.value = value;
                form.appendChild(input);
            });
        } else {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
        }
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
}
